import React from 'react'
import { Image, Linking } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import Pressable from '@zet/design-system/pressable'

import { BannerResponseData } from '../../api/brands/types'
import { parseCMSScreenOptions } from '../../utils'
import { REDIRECTION_LINK } from '../../utils/constants'

const BannerCard = ({
  width,
  bannerData,
}: {
  width: number
  bannerData: BannerResponseData
}) => {
  const { navigate } = useNavigation()
  const screenName = bannerData?.redirect?.screenName
  const options = bannerData?.redirect?.options

  const handleBannerClick = () => {
    if (screenName) {
      publishEvent('click_action', bannerData?.trackEventPayload)
      if (screenName === REDIRECTION_LINK) {
        Linking.openURL(options?.url)
      } else {
        navigate(screenName, parseCMSScreenOptions(options))
      }
    }
  }

  if (!bannerData?.imageUrl) {
    return null
  }
  return (
    <Pressable onPress={handleBannerClick} className="items-center">
      <Image
        source={{ uri: bannerData?.imageUrl }}
        style={{
          width,
          aspectRatio: 16 / 9,
          borderRadius: 8,
        }}
        resizeMode="contain"
      />
    </Pressable>
  )
}

export default BannerCard
